import React from 'react';
import Select from 'react-select';
import * as styles from '../../../config/styles'

const MultiSelect = (props) => {
    const options = props.options
    const value = props.value
    const clearable = props.clearable || false
    const placeholder = props.placeholder || ''
    const disabled = props.disabled
    const onChange = props.onChange
    const styleName = props.styleName || "multiSelect"
    const style = styles[styleName]

    const localOnChange = (newValue, actionMeta) => {
        switch (actionMeta.action) {
            case 'remove-value':
            case 'pop-value':
                if (actionMeta.removedValue.isFixed) {
                    return;
                }
                break;
            case 'clear':
                newValue = value.filter((v) => v.isFixed);
                break;
        }
        onChange(newValue)
    }
    
    return (
        <Select
            isMulti={true}
            key={props.name}
            name={props.name}
            value={value}
            onChange={localOnChange}
            options={options}
            styles={style}
            clearable={clearable}
            isDisabled={disabled}
            placeholder={placeholder}
            closeMenuOnSelect={false}
        />
    )
}

export default MultiSelect
